import DialogModal from '@/components/DialogModal';
import { trackActionDeleted } from '@/utils/tracking';
import { useTranslation } from 'react-i18next';

type Props = {
  isOpen: boolean;
  onCloseDeleteActionModal: () => void;
  onDeleteAction: () => void;
  hasFrequency: boolean;
};

const DeleteActionModal = ({ isOpen, onCloseDeleteActionModal, onDeleteAction, hasFrequency }: Props) => {
  const { t } = useTranslation('DeleteActionModal');
  return (
    <DialogModal
      isOpen={isOpen}
      title={hasFrequency ? t('title.deleteRecurringAction') : t('title.deleteAction')}
      message={hasFrequency ? t('messages.confirmDeleteRecurringAction') : t('messages.confirmDelete')}
      onCancel={onCloseDeleteActionModal}
      onConfirm={() => {
        onDeleteAction();
        trackActionDeleted();
      }}
      confirmVariant="danger"
      confirmText={t('buttons.deleteAction')}
      cancelText={t('buttons.cancel')}
    />
  );
};

export default DeleteActionModal;
